import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAutoApplyModeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAutoApplyModeQuery = {
    __typename?: 'Query';
    autoApplyInfo?:
        | { __typename?: 'AutoApplyInfoPayload'; mode?: Types.AutoApplyMode | null | undefined }
        | null
        | undefined;
};

export type UpdateAutoApplyModeMutationVariables = Types.Exact<{
    input: Types.UpdateAutoApplyInput;
}>;

export type UpdateAutoApplyModeMutation = {
    __typename?: 'Mutation';
    updateAutoApply: {
        __typename?: 'UpdateAutoApplyPayload';
        mode?: Types.AutoApplyMode | null | undefined;
    };
};

export const GetAutoApplyModeDocument = gql`
    query GetAutoApplyMode {
        autoApplyInfo {
            mode
        }
    }
`;

/**
 * __useGetAutoApplyModeQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyModeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoApplyModeQuery(
    baseOptions?: Apollo.QueryHookOptions<GetAutoApplyModeQuery, GetAutoApplyModeQueryVariables>,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAutoApplyModeQuery, GetAutoApplyModeQueryVariables>(
        GetAutoApplyModeDocument,
        options,
    );
}
export function useGetAutoApplyModeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyModeQuery,
        GetAutoApplyModeQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAutoApplyModeQuery, GetAutoApplyModeQueryVariables>(
        GetAutoApplyModeDocument,
        options,
    );
}
export function useGetAutoApplyModeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetAutoApplyModeQuery, GetAutoApplyModeQueryVariables>,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetAutoApplyModeQuery, GetAutoApplyModeQueryVariables>(
        GetAutoApplyModeDocument,
        options,
    );
}
export type GetAutoApplyModeQueryHookResult = ReturnType<typeof useGetAutoApplyModeQuery>;
export type GetAutoApplyModeLazyQueryHookResult = ReturnType<typeof useGetAutoApplyModeLazyQuery>;
export type GetAutoApplyModeSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyModeSuspenseQuery
>;
export type GetAutoApplyModeQueryResult = Apollo.QueryResult<
    GetAutoApplyModeQuery,
    GetAutoApplyModeQueryVariables
>;
export const UpdateAutoApplyModeDocument = gql`
    mutation UpdateAutoApplyMode($input: UpdateAutoApplyInput!) {
        updateAutoApply(input: $input) {
            mode
        }
    }
`;
export type UpdateAutoApplyModeMutationFn = Apollo.MutationFunction<
    UpdateAutoApplyModeMutation,
    UpdateAutoApplyModeMutationVariables
>;

/**
 * __useUpdateAutoApplyModeMutation__
 *
 * To run a mutation, you first call `useUpdateAutoApplyModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoApplyModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoApplyModeMutation, { data, loading, error }] = useUpdateAutoApplyModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutoApplyModeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateAutoApplyModeMutation,
        UpdateAutoApplyModeMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<UpdateAutoApplyModeMutation, UpdateAutoApplyModeMutationVariables>(
        UpdateAutoApplyModeDocument,
        options,
    );
}
export type UpdateAutoApplyModeMutationHookResult = ReturnType<
    typeof useUpdateAutoApplyModeMutation
>;
export type UpdateAutoApplyModeMutationResult = Apollo.MutationResult<UpdateAutoApplyModeMutation>;
export type UpdateAutoApplyModeMutationOptions = Apollo.BaseMutationOptions<
    UpdateAutoApplyModeMutation,
    UpdateAutoApplyModeMutationVariables
>;
